module.exports = __webpack_public_path__ + "static/media/cover6.c25ea02c.jpg";